import {
  REPORT_CONTRACT_ITEMS_BY_CUSTOMER,
  REPORT_CONTRACT_ITEMS_BY_CUSTOMER_SUCCESS,
  REPORT_CONTRACT_ITEMS_BY_CUSTOMER_FAIL,
} from "./actionType";

//get list contract items by customer
export const reportContractItemsByCustomer = (params) => {
  return {
    type: REPORT_CONTRACT_ITEMS_BY_CUSTOMER,
    params,
  };
};

export const reportContractItemsByCustomerSuccess = (payload) => {
  return {
    type: REPORT_CONTRACT_ITEMS_BY_CUSTOMER_SUCCESS,
    payload,
  };
};

export const reportContractItemsByCustomerFail = (payload) => {
  return {
    type: REPORT_CONTRACT_ITEMS_BY_CUSTOMER_FAIL,
    payload,
  };
};
